import {createSlice, createAction} from '@reduxjs/toolkit'
import {
    updateRoom,
    lockRoom,
    unlockRoom,
    getPermissionsByUserId
} from './RoomMenuThunks';

import { mapSocketFactory } from "../../../../utils/socketFactory";

const initialState = {
    locked:false,
    showReservationPopup:false,
    initialReservation:null,
    updateRoom:null,
    openUpdateRoom:false,
    alllockedRooms:[],
    showAllMeetings:false,
    openedOngoingMeetingId: null,
    openedUpcomingMeetingId: null,
}

const applyNeededInit = (state,payload) => {
    state.openedMeetingId = null; 
}
 const roomMenuSlice = createSlice({
    name:'roomMenu',
    initialState,
    reducers:{
        setLocked:(state,action)=>{
            state.locked = action.payload
        },
        setShowReservationPopup:(state,action)=>{
            state.showReservationPopup = action.payload
        },
        setInitialReservation:(state,action)=>{
            state.initialReservation = action.payload
        },
        setUpdateRoom:(state,action)=>{
            state.updateRoom = action.payload
        },
        setOpenUpdateRoom:(state,action)=>{
            state.openUpdateRoom = action.payload
        },
        setLockedRooms:(state,action)=>{
            state.alllockedRooms = action.payload
        },
        setShowAllMeetings:(state,action)=>{
            state.showAllMeetings = action.payload
        },
        setOpenedOngoingMeetingId:(state, action)=>{
        state.openedOngoingMeetingId = action.payload;
        },
        setOpenedUpcomingMeetingId:(state, action)=>{
            state.openedUpcomingMeetingId = action.payload;
        },

    },
          extraReducers: (builder) => {
            builder
                .addCase(updateRoom.fulfilled, (state, action) => {
                    console.log("update room  success")
                })
                .addCase(updateRoom.rejected, (state, action) => {
                    state.error = action.payload || 'Failed to change room';
                })
    
            .addCase(lockRoom.fulfilled, (state, action) => {
                console.log('lock Room success');
                state.locked = true; // Set locked to true on successful lock
                state.error = null; // Clear error on success
            })
            .addCase(lockRoom.rejected, (state, action) => {
                state.error = action.payload || 'Failed to lock Room';
            })

            .addCase(unlockRoom.fulfilled, (state, action) => {
                console.log('unlock Room success');
                state.locked = false; // Set locked to false on successful unlock
                state.error = null; // Clear error on success
            })
            .addCase(unlockRoom.rejected, (state, action) => {
                state.error = action.payload || 'Failed to unlock Room';
            })
            .addCase(getPermissionsByUserId.fulfilled, (state, action) => {
                applyNeededInit(state,action.payload);
            });
        },
})

export const {
    setLocked,
    setShowReservationPopup,
    setInitialReservation,
    setUpdateRoom,
    setOpenUpdateRoom,
    setLockedRooms,
    setShowAllMeetings,
    setOpenedOngoingMeetingId,
    setOpenedUpcomingMeetingId  
} = roomMenuSlice.actions;


export const UPDATE_ROOMS = mapSocketFactory.emit('updateRoom', 'socket/roomUpdated');
export const LOCKED_ROOMS = mapSocketFactory.emit('lockedRooms', 'socket/lockedRooms');
export const copyRoomLink = createAction("roomMenu/copyRoomLink");



export default roomMenuSlice.reducer